import React from 'react';
import { Users, BookCopy, Gift, Star } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-carbon text-cream py-8 px-4 border-y-4 border-brand-green" data-id="element-248">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-249">
        <div className="flex flex-col items-center justify-center" data-id="element-250">
          <Users className="w-8 h-8 mb-2 text-brand-green" data-id="element-251" />
          <p className="font-bold text-xl md:text-2xl" data-id="element-252">+300</p>
          <p className="text-sm text-cream-dark" data-id="element-253">
            familias y emprendedores confían
          </p>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-254">
          <BookCopy className="w-8 h-8 mb-2 text-brand-green" data-id="element-255" />
          <p className="font-bold text-xl md:text-2xl" data-id="element-256">6 Tomos</p>
          <p className="text-sm text-cream-dark" data-id="element-257">listos</p>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-258">
          <Gift className="w-8 h-8 mb-2 text-brand-green" data-id="element-259" />
          <p className="font-bold text-xl md:text-2xl" data-id="element-260">3 Bonos</p>
          <p className="text-sm text-cream-dark" data-id="element-261">incluidos</p>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-262">
          <div className="flex gap-1 mb-2 text-yellow-400" data-id="element-263">
            <Star className="w-6 h-6 fill-current" data-id="element-264" />
            <Star className="w-6 h-6 fill-current" data-id="element-265" />
            <Star className="w-6 h-6 fill-current" data-id="element-266" />
            <Star className="w-6 h-6 fill-current" data-id="element-267" />
            <Star className="w-6 h-6 fill-current" data-id="element-268" />
          </div>
          <p className="font-bold text-xl md:text-2xl" data-id="element-269">4.9/5</p>
          <p className="text-sm text-cream-dark" data-id="element-270">calificación ⭐</p>
        </div>
      </div>
    </div>;
}